import React, {useRef} from 'react';
import {Link} from 'react-router-dom';
import CopyrightedImage from '../partials/CopyrightedImage';
import {useTranslation} from '../../config/TranslationProvider';

const LocationsCard = ({location: {medialist, id, title, address, zip, city}}) => {
    const linkRef = useRef(null);

    const image = medialist && medialist[0];

    return (
        <article className="atbd_single_listing_wrapper" onClick={() => linkRef.current?.click()}>

            <figure className="atbd_listing_thumbnail_area">
                <div className="atbd_listing_image">
                    {image &&
                        <CopyrightedImage image={image} size="medium" alt="Vorschaubild des Veranstaltungsortes" />}
                </div>
            </figure>

            <div className="atbd_listing_info">
                <div className="atbd_content_upper">
                    <Link to={'/locations/' + id} aria-label={useTranslation('to_the_location') + ' ' + title} ref={linkRef}>
                        <h3 className="atbd_listing_title">{title}</h3>
                    </Link>
                    <div className="atbd_listing_data_list">
                        <ul>
                            <li>
                                <p><span className="la la-map-marker" />{address}</p>
                            </li>
                            <li>
                                <p><span className="la la-building" />{zip}, {city}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </article>
    );
};

export default LocationsCard;
